import React from 'react';
import { Button } from '@spark/ui-components/components/Button';
import Icon from '@spark/ui-components/components/Icon';

export const getRotaColumns = (onSelect) => [
  {
    id: 'codigoIntegracao',
    accessorKey: 'CodigoIntegracao',
    header: 'Código',
    size: 80,
    cell: ({ row }) =>
      row.original.CodigoIntegracao ??
      row.original.codigoIntegracao ??
      row.original.Codigo ??
      row.original.codigo ??
      '-',
  },
  {
    id: 'descricao',
    accessorKey: 'Descricao',
    header: 'Descrição',
    size: 320,
    cell: ({ row }) => {
      const descricao = row.original.Descricao ?? row.original.descricao ?? '-';
      return <div style={{ fontWeight: '500' }}>{descricao}</div>;
    },
  },
  {
    id: 'ativo',
    accessorKey: 'Ativo',
    header: 'Ativo',
    size: 100,
    cell: ({ row }) => {
      const ativo = row.original.Ativo ?? row.original.ativo;
      if (ativo === 1 || ativo === '1' || ativo === true) return 'Sim';
      if (ativo === 0 || ativo === '0' || ativo === false) return 'Não';
      return '-';
    },
  },
  {
    id: 'acoes',
    header: 'Selecionar',
    size: 120,
    cell: ({ row }) => (
      <Button
        variant="primary"
        size="sm"
        onClick={(e) => {
          e.stopPropagation();
          onSelect(row.original);
        }}
      >
        <Icon name="check" size={16} />
        Selecionar
      </Button>
    ),
    enableSorting: false,
  },
];
